module.exports = __webpack_public_path__ + "img/room-placeholder.ab5e52b4.jpg";